// @flow

import * as React from "react";
import { groupBy } from "lodash";
import { getFullItem, getSupplier } from "../../reducers/baby-list-invoice";
import { toDinero } from "../../util";

class InvoiceSupplierTotals extends React.Component<*> {
  render() {
    const { items, searchItems, suppliers } = this.props;
    const fullItems = groupBySupplier(items, searchItems);
    if (Object.keys(fullItems).length == 0) return null;
    return (
      <div className="invoice-side-block panel">
        <h2>Suppliers</h2>
        {Object.keys(fullItems).map((supplierId) => {
          const items = fullItems[supplierId];
          const supplier = getSupplier(suppliers, items[0].supplierId);
          const total = items.reduce((total, i) => {
            return total + parseInt(i.priceSelling); //* i.amount
          }, 0);
          return (
            <div key={`slis-${supplierId}`} className="mb-4">
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <strong>{supplier.name}</strong>
                <div>{toDinero(total).toFormat("$0,0.00")}</div>
              </div>

              {items.map((i, idx) => (
                <div
                  key={`blis-${supplierId}-${idx}`}
                  className="d-flex text-gray"
                  style={{ justifyContent: "space-between" }}
                >
                  <div>{i.name}</div>
                  <div>
                    {toDinero(parseInt(i.priceSelling)).toFormat("$0,0.00")}
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  }
}

const groupBySupplier = (items, searchItems) => {
  items = items
    .map((i) => i.items)
    .flat()
    .map((i) => {
      const found = getFullItem(searchItems, i.babyListItemId);
      return found ? { ...found, amount: i.amount } : found;
    })
    .filter((i) => i.supplierId != null);
  return groupBy(items, (i) => i.supplierId);
};

export default InvoiceSupplierTotals;
